module.exports = "./img/db388d6fe97ac8f27375cac5b03612ac.jpg";